<template>
	<div>
		<div class="main">
			<ul class="main_top">
				<li @click="throttle(isCoupon,2000)" :class="[couponStatus?'on':'']" class="showHand">未使用</li>
				<li @click="throttle(noCoupon,2000)" :class="[nullStatus?'on':'']" class="showHand">已使用</li>
			</ul>
			<div class="null" v-if="list && !list.length && couponStatus || nolist&&!nolist.length&&nullStatus">
				<img src="../../../assets/img/privacy/noCollection.png">
				<p>暂无优惠券</p>
			</div>
			<ul class="list" v-show="couponStatus" v-else>
				<li v-for="(item,index) in list" :key="index">
					<img :src="item.coupon_settings_back_img">
					<div class="couponNav">
						<div class="couponNav_left">
							<p class="one-txt-cut">{{item.coupon_amount}}元{{item.coupon_request}}优惠券</p>
							<span>有效期至：{{item.coupon_time}}</span>
						</div>
						<p class="use showHand" @click="jump">立即使用</p>
					</div>
				</li>
			</ul>
			<ul class="list" v-show="nullStatus">
				<li v-for="(item,index) in nolist" :key="index">
					<img :src="item.coupon_settings_back_img_h">
					<div class="couponNav">
						<div class="couponNav_left">
							<p>{{item.coupon_amount}}元无门槛优惠券</p>
							<span>有效期至：{{item.coupon_time}}</span>
						</div>
						<img src="../../../assets/img/privacy/noUse.png" class="noUse">
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { selByList } from "@/api/coupon.js"
	let _self;
	export default {
		name: "",
		data() {
			return {
				couponNav:null,
				userInfo:null,
				// 未使用
				couponStatus: true,
				// 已使用
				nullStatus: false,
				//是否允许请求
				isrequest:true,
				list: [
					// {
					// 	img: require('../../../assets/img/privacy/couponImg.png'),
					// 	money: 20,
					// 	time: "永久"
					// }
				],
				nolist: [
					// {
					// 	img: require('../../../assets/img/privacy/nocoupon.png'),
					// 	money: 40,
					// 	time: "永久"
					// }
				]
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			
			//获取地址信息
			_self.getCouponList(0);
		},
		// 方法集
		methods: {
			//获取优惠券信息
			getCouponList(val){
				if(!_self.isrequest) return;
				_self.isrequest=false;
				selByList({
					page:'1',
					size:'50',
					userId:_self.userInfo.userId,
					ucStatus:val
				}).then(res=>{
					if(res.data&&res.code==200){
						_self.isrequest=true;
						if(val==0){
							_self.list=res.data.list;
						}else{
							_self.nolist=res.data.list;
						}
					}
				})
			},
			//未使用
			isCoupon() {
				_self.getCouponList(0);
				_self.couponStatus = !_self.couponStatus;
				if (_self.couponStatus) {
					_self.message = '隐藏'
					_self.nullStatus = false
				} else {
					_self.message = '显示'
				}
			},
			// 已使用
			noCoupon() {
				_self.getCouponList(1);
				_self.nullStatus = !_self.nullStatus;
				if (_self.nullStatus) {
					_self.message = '隐藏'
					_self.couponStatus = false
				} else {
					_self.message = '显示'
				}
			},
			//跳转到首页
			jump() {
				_self.$router.push('/')
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background-color: #FFFFFF;
		padding: 20px 30px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.main_top {
		display: flex;
		flex-direction: row;
	}

	.main_top li {
		width: 70px;
		padding: 5px 8px;
		box-sizing: border-box;
		margin-right: 15px;
		font-size: 16px;
		letter-spacing: 2px;
	}

	.on {
		color: #e62129;
		border-bottom: 2px solid #e62129;
	}

	.list {
		width: 850px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: space-between;
		padding: 50px 40px 160px 40px;
		box-sizing: border-box;
		/* margin-bottom: 160px; */
	}

	.list li {
		width: 355px;
		height: 68px;
		position: relative;
		margin-bottom: 30px;
	}

	.list li img {
		width: 355px;
		height: 68px;
	}

	.couponNav {
		width: 304px;
		height: 50px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.couponNav_left {
		width: 160px;
		height: 50px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.couponNav_left p {
		font-size: 16px;
		font-weight: 700;
		color: #ffffff;
		line-height: 18px;
	}

	.couponNav_left span {
		font-size: 10px;
		font-weight: 400;
		color: #ffffff;
		line-height: 18px;
	}

	.use {
		font-weight: 700;
		color: #ffffff;
		line-height: 18px;
		font-size: 14px;
	}

	.noUse {
		width: 48px !important;
		height: 36px !important;
	}

	.null {
		width: 352px;
		height: 391px;
		margin: 40px 330px 0 320px;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 18px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 1px;
	}

	.null img {
		width: 352px;
		height: 352px;
		display: block;
	}
</style>
